import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default createStore({
  plugins: [vuexLocal.plugin],
  state: {
    user: {
      ip: null,
      id: null,
      token: null,
      expires: 0,
      username: null,
      permissions: [],
      operators: [],
      payment: null,
      payoutNotification: true,
      topupNotification: true,
      phone: null,
    },
    selectedOperator: null,
    language: 'th',
    financeModuleCode: []
  },
  mutations: {
    setUserPayment(state, value) {
      state.user.payment = value
    },
    serUserPayoutNotification(state, value) {
      state.user.payoutNotification = value
    },
    serUserTopupNotification(state, value) {
      state.user.topupNotification = value
    },
    updateIpAddress(state, value) {
      state.user.ip = value
    },
    setUserToken(state, value) {
      state.user.token = value.token
      state.user.username = value.username
      state.user.expires = value.exp
      state.user.id = value.userId
      state.user.permissions = value.permissions
      state.user.phone = value.phone
    },
    setAppLanguage(state, value) {
      state.language = value.language
    },
    removeUserInfo(state) {
      state.user.ip = null
      state.user.token = null
      state.user.username = null
      state.user.expires = 0
      state.user.permissions = []
      state.user.phone = null
    },
    setOperators(state, value) {
      state.user.operators = value
    },
    removeOperators(state) {
      state.user.operators = []
    },
    updateSelectedOperator(state, value) {
      state.selectedOperator = value
    },
    setFinanceModuleCode(state, value) {
      state.financeModuleCode = value
    }
  },
  actions: {
  },
  modules: {
  }
})
